import { render, staticRenderFns } from "./AuctionsModuleLayout.vue?vue&type=template&id=b66d0346"
import script from "./AuctionsModuleLayout.vue?vue&type=script&lang=js"
export * from "./AuctionsModuleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports